import { render, staticRenderFns } from "./KouzuiLayer.vue?vue&type=template&id=31aabf86&scoped=true&"
import script from "./KouzuiLayer.vue?vue&type=script&lang=js&"
export * from "./KouzuiLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aabf86",
  null
  
)

export default component.exports